import { DraggableProvidedDragHandleProps } from 'react-beautiful-dnd'

import {
  Box as DarkBox,
  DragHandleIcon,
  EditIcon,
  FeedItem,
  FloorsIcon,
  IconButton,
  tokenVar,
} from '@hivewatch/dark'

import { DarkDefaultFloorIndicator } from './DarkDefaultFloorIndicator'

interface DarkFloorListItemIProps {
  colorScheme: 'dark' | 'light'
  hasIncidents: boolean
  isCurrentFloor?: boolean
  isDefaultFloor: boolean
  isEditEnabled?: boolean
  label: string
  onClick: () => void
  onEditButtonClick?: (event: React.MouseEvent) => void
  dragHandleProps?: DraggableProvidedDragHandleProps | null
  editButtonAriaLabel?: string
}

export const DarkFloorListItem = ({
  colorScheme,
  hasIncidents,
  isCurrentFloor = false,
  isDefaultFloor,
  isEditEnabled = false,
  label,
  onClick,
  onEditButtonClick,
  dragHandleProps,
  editButtonAriaLabel = 'Edit floor',
}: DarkFloorListItemIProps) => {
  // Markup-A: the leading layers icon is tinted red when the floor has open
  // incidents; otherwise it inherits the FeedItem icon color.
  const incidentColor = tokenVar(
    colorScheme === 'light'
      ? 'colors.light.status.error'
      : 'colors.status.error'
  )
  const handleColor = tokenVar(
    colorScheme === 'light'
      ? 'colors.light.icon.secondary'
      : 'colors.icon.secondary'
  )

  return (
    <DarkBox alignItems='center' display='flex' gap='4px' width='100%'>
      {dragHandleProps && (
        <DarkBox
          {...dragHandleProps}
          alignItems='center'
          cursor='grab'
          data-testid='floorPlanPage_darkFloorsPanel_dragHandle'
          display='flex'
          onClick={(e) => e.stopPropagation()}
        >
          <DragHandleIcon color={handleColor} size={18} />
        </DarkBox>
      )}
      <DarkBox flex={1} minWidth={0}>
        <FeedItem
          ariaLabel={label}
          colorScheme={colorScheme}
          icon={
            <FloorsIcon
              color={hasIncidents ? incidentColor : undefined}
              size={20}
            />
          }
          isSelected={isCurrentFloor}
          message={label}
          onClick={onClick}
          trailingAction={
            <DarkBox alignItems='center' display='flex' gap='8px'>
              {isEditEnabled && onEditButtonClick && (
                <IconButton
                  aria-label={editButtonAriaLabel}
                  colorScheme={colorScheme}
                  data-testid='floorPlanPage_darkFloorsPanel_editButton'
                  dimension={28}
                  icon={<EditIcon size={14} />}
                  onClick={(e) => {
                    e.stopPropagation()
                    onEditButtonClick(e)
                  }}
                />
              )}
              {isDefaultFloor && (
                <DarkDefaultFloorIndicator colorScheme={colorScheme} />
              )}
            </DarkBox>
          }
        />
      </DarkBox>
    </DarkBox>
  )
}
